import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "tw-flex tw-justify-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "tw-text-[24px] tw-text-[#00A0DA] tw-mt-3 tw-mb-4" }, " REALTOR FORMAT ")
], -1)
const _hoisted_2 = { class: "d-flex justify-content-between pb-4 px-4 gap-5 bg-white rounded-4" }
const _hoisted_3 = { class: "w-50" }
const _hoisted_4 = { class: "d-flex justify-content-between pb-4 px-4 gap-5 bg-white rounded-4 tw-items-center" }
const _hoisted_5 = { class: "w-50" }
const _hoisted_6 = { class: "pb-3" }
const _hoisted_7 = { class: "d-flex justify-content-between pb-4 px-4 gap-5 bg-white rounded-4" }
const _hoisted_8 = { class: "w-50" }
const _hoisted_9 = { class: "d-flex justify-content-between pb-4 px-4 gap-5 bg-white rounded-4 tw-items-center" }
const _hoisted_10 = { class: "w-50" }
const _hoisted_11 = { class: "pb-3" }
const _hoisted_12 = { class: "tw-flex tw-justify-center tw-pb-4" }

import axios from "axios";
import { ref, toRefs } from "vue"

import AnnualAverageCapitalGain from "./AnnualAverageCapitalGain.vue"
import AuctionCourtPayment from "./AuctionCourtPayment.vue"
import AttorneyPayment from "./AttorneyPayment.vue"
import Commissions from "./Commissions.vue"
import AverageTaxesAndInsurance from "./AverageTaxesAndInsurance.vue"

import { useToast } from "@/composables/useToast";
import { environment } from "@/environment";


export default /*#__PURE__*/_defineComponent({
  __name: 'RealtorFormat',
  props: {
    userId: Number,
},
  setup(__props) {

const props = __props;

const toast = useToast();

const url = environment.URL_API;



const { userId } = toRefs(props)

const loading = ref(false)

const annualAverageCapitalGain = ref({
    ID: null,
    user_id: userId.value,
    town_house: 0,
    condo: 0,
    single_house: 0,
    villa: 0,
    mobile: 0,
    others: 0,
})

const auctionCourtPayment = ref({
    ID: null,
    user_id: userId.value,
    clerck_fee: 0,
    doc_stamp: 0,
    lawyer_hourly_price: 0,
})

const attorneyPayment = ref({
    ID: null,
    user_id: userId.value,
    number_for_hours: 0,
})

const commissions = ref({
    ID: null,
    user_id: userId.value,
    buyer_agent_commission: 0,
    seller_agents_commission: 0,
    real_estate_broker_fee: 0,
})

const averageTaxesAndInsurance = ref({
    ID: null,
    user_id: userId.value,
    property_taxes: 0,
    federal_taxes: 0,
    property_insurance: 0,
    property_flood_insurance: 0,
})

const getData = async () => {
    loading.value = true;
    const response = await axios(
        `${url}realtor-format?user_id=${userId.value}`,
        {
            method: "GET",
        }
    );

    if (!response.data.error) {
        annualAverageCapitalGain.value = response.data.annualAverageCapitalGain
            ? response.data.annualAverageCapitalGain
            : {
                ID: null,
                user_id: userId.value,
                town_house: 0,
                condo: 0,
                single_house: 0,
                villa: 0,
                mobile: 0,
                others: 0,
            };
        auctionCourtPayment.value = response.data.auctionCourtPayment
            ? response.data.auctionCourtPayment
            : {
                ID: null,
                user_id: userId.value,
                clerck_fee: 0,
                doc_stamp: 0,
                lawyer_hourly_price: 0,
            };
        attorneyPayment.value = response.data.attorneyPayment
            ? response.data.attorneyPayment
            : {
                ID: null,
                user_id: userId.value,
                number_for_hours: 0,
            };
        commissions.value = response.data.commissions
            ? response.data.commissions
            : {
                ID: null,
                user_id: userId.value,
                buyer_agent_commission: 0,
                seller_agents_commission: 0,
                real_estate_broker_fee: 0,
            };
        averageTaxesAndInsurance.value = response.data.averageTaxesAndInsurance
            ? response.data.averageTaxesAndInsurance
            : {
                ID: null,
                user_id: userId.value,
                property_taxes: 0,
                federal_taxes: 0,
                property_insurance: 0,
                property_flood_insurance: 0,
            };
        loading.value = false;
    }
};
const submitTable = async () => {
    loading.value = true;
    const response = await axios(`${url}realtor-format`, {
        method: "POST",
        data: {
            annualAverageCapitalGain: annualAverageCapitalGain.value,
            auctionCourtPayment: auctionCourtPayment.value,
            attorneyPayment: attorneyPayment.value,
            commissions: commissions.value,
            averageTaxesAndInsurance: averageTaxesAndInsurance.value
        },
    });

    if (!response.data.error) {
        loading.value = false;
        await toast.success(response.data.message, {
            position: "top-end",
            timer: 3000,
            showCloseButton: true,
        });
        getData()
    } else {
        loading.value = false;
        await toast.error(response.data.message, {
            position: "top-end",
            timer: 3000,
            showCloseButton: true,
        });
    }
}

getData();

return (_ctx: any,_cache: any) => {
  const _component_Loader = _resolveComponent("Loader")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Loader, { visible: loading.value }, null, 8, ["visible"]),
    _hoisted_1,
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(AnnualAverageCapitalGain, { annualAverageCapitalGain: annualAverageCapitalGain.value }, null, 8, ["annualAverageCapitalGain"])
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(AuctionCourtPayment, { auctionCourtPayment: auctionCourtPayment.value }, null, 8, ["auctionCourtPayment"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(Commissions, { commissions: commissions.value }, null, 8, ["commissions"])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createVNode(AverageTaxesAndInsurance, { averageTaxesAndInsurance: averageTaxesAndInsurance.value }, null, 8, ["averageTaxesAndInsurance"])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("button", {
        class: "tw-bg-[#00a0da] tw-text-white tw-h-[40px] tw-font-bold tw-w-[250px] tw-rounded-full tw-text-xl",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (submitTable()))
      }, " SAVE ")
    ])
  ], 64))
}
}

})